import { showTokenTransactionPopup } from '@/core/presenter/controller/PopupController';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  tokenTransaction: ViewModel.IResponseActivity;
  onClickCopyBtn?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TokenTransactionItem = ({ tokenTransaction }: IProps) => {
  const handleClickTokenTransactionItem = useCallback(() => {
    showTokenTransactionPopup(tokenTransaction);
  }, [tokenTransaction]);

  const handleCopyClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.preventDefault();
    e.stopPropagation();

    const text = tokenTransaction.type === '보내기' ? tokenTransaction.to : tokenTransaction.from;
    navigator.clipboard.writeText(text);
  };

  const isSend = tokenTransaction.type === '보내기';
  const memo = isSend ? tokenTransaction.to_memo : tokenTransaction.from_memo;

  return (
    <div className="activity-item" data-type={tokenTransaction.type} onClick={handleClickTokenTransactionItem}>
      <p className="activity-date text-sm font-normal">{tokenTransaction.date}</p>
      
      <div className="activity-row">
        <div className="activity-left">
          <div className={clsx('activity-icon-wrapper', { send: isSend, receive: !isSend })}>
            <img 
              src={`./images/${isSend ? 'send' : 'receive'}-icon.png`} 
              alt={tokenTransaction.type} 
              className="activity-icon" 
            />
            <span className="activity-coin-badge text-xs font-normal">{tokenTransaction.coinType}</span>
          </div>
          <div className="activity-main">
            <div className="activity-type-row">
              <span className="activity-type text-sm font-semibold">{tokenTransaction.type}</span>
              <span
                className={clsx('activity-status text-sm font-medium', {
                  success: tokenTransaction.status === '성공',
                  fail: tokenTransaction.status === '실패',
                })}
              >
                {tokenTransaction.status}
              </span>
            </div>
          </div>
        </div>
        
        <div className="activity-center">
          <div className="activity-address-row">
            <span className="text-xs font-normal">
              {isSend ? '→' : '←'} {isSend ? tokenTransaction.to_short : tokenTransaction.from_short}
            </span>
            <button type="button" className="copy-btn-small" onClick={handleCopyClick}>
              <img src="./images/copy-icon.png" alt="복사" className="copy-icon-small" />
            </button>
          </div>
          {memo && <p className="activity-memo text-sm font-normal">{memo}</p>}
        </div>
        
        <div className="activity-right">
          <p className="amount-value text-base font-semibold">{tokenTransaction.amount}</p>
          <p className="amount-krw text-sm font-normal">{tokenTransaction.krwAmount}</p>
        </div>
      </div>
    </div>
  );
};

export default TokenTransactionItem;
